<template>
  <div class="mt-3 w-100 price-detail-8 d-flex">
    <div class="w-50 border-right d-flex price-item">
      <div class="w-50">Tổng tiền hàng trả</div>
      <div class="w-50 text-right">
        <b>{{formatMoneyNotUnit(Math.ceil(haveProps ? (returnPrice) : getReturnPrice ))  }}đ</b>
      </div>
    </div>
    <div class="w-50 d-flex price-item">
      <div class="w-50">Tổng tiền hàng đổi</div>
      <div class="w-50 text-right">
        <b>{{ formatMoneyNotUnit(Math.ceil(haveProps ? exchangePrice : getExchangePrice)) }}đ</b>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  props: {
    returnPrice: {
      type: Number,
    },
    exchangePrice: {
      type: Number,
    },
  },
  data() {
    return {
      haveProps: false
    }
  },

  created() {
    if(this.returnPrice != undefined) {
      this.haveProps = true
    }
  },

  methods: {
    ...mapMutations("ordersReturn", ["setReturnPrice", "setExchangePrice"]),
  },

  computed: {
    ...mapGetters("ordersReturn", [
      "getReturnPrice",
      "getExchangePrice",
    ]),
  }
};
</script>

<style lang="scss" scoped>
.price-detail-8 {
  background-color: #fff9ec;
  border-radius: 8px;
  padding: 12px 0;
  .price-item {
    padding: 6px 70px;
  }
}
.border-right {
  border-right: 1px solid #ffcd69 !important;
}
</style>
